"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
export function RecipientSelection(t0) {
  const $ = _c(35);
  const {
    initialValue: t1,
    placeholder: t2,
    title: t3,
    description: t4,
    confirmText: t5,
    onBack,
    onConfirm,
    autoFocus: t6,
    validateAddress,
    classes
  } = t0;
  const initialValue = t1 === undefined ? "" : t1;
  const placeholder = t2 === undefined ? "Enter recipient address" : t2;
  const title = t3 === undefined ? "Add recipient address or ENS" : t3;
  const description = t4 === undefined ? "Swap and send tokens to another address" : t4;
  const confirmText = t5 === undefined ? "Confirm recipient address" : t5;
  const autoFocus = t6 === undefined ? true : t6;
  const [recipientAddress, setRecipientAddress] = useState(initialValue);
  let t7;
  let t8;
  if ($[0] !== initialValue) {
    t7 = () => {
      setRecipientAddress(initialValue);
    };
    t8 = [initialValue];
    $[0] = initialValue;
    $[1] = t7;
    $[2] = t8;
  } else {
    t7 = $[1];
    t8 = $[2];
  }
  useEffect(t7, t8);
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = async () => {
      ;
      try {
        const text = await navigator.clipboard.readText();
        setRecipientAddress(text);
      } catch (t10) {
        const err = t10;
        console.error("Failed to read clipboard:", err);
      }
    };
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const handlePaste = t9;
  let t10;
  if ($[4] !== onConfirm || $[5] !== recipientAddress || $[6] !== validateAddress) {
    t10 = () => {
      if (recipientAddress && (!validateAddress || validateAddress(recipientAddress))) {
        onConfirm(recipientAddress);
      }
    };
    $[4] = onConfirm;
    $[5] = recipientAddress;
    $[6] = validateAddress;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const handleConfirm = t10;
  let t11;
  if ($[8] !== handleConfirm || $[9] !== recipientAddress) {
    t11 = e => {
      if (e.key === "Enter" && recipientAddress) {
        handleConfirm();
      }
    };
    $[8] = handleConfirm;
    $[9] = recipientAddress;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const handleKeyDown = t11;
  let t12;
  if ($[11] !== recipientAddress || $[12] !== validateAddress) {
    t12 = !validateAddress || !recipientAddress || validateAddress(recipientAddress);
    $[11] = recipientAddress;
    $[12] = validateAddress;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const isAddressValid = t12;
  const canConfirm = recipientAddress && isAddressValid;
  const t13 = classes?.container || "recipient-selection mx-auto w-full max-w-[460px] p-5";
  const t14 = classes?.header || "flex justify-around";
  const t15 = classes?.backButton || "text-as-quaternary hover:text-as-primary flex h-8 w-8 items-center justify-center rounded-lg transition-colors";
  let t16;
  if ($[14] !== autoFocus || $[15] !== canConfirm || $[16] !== classes?.confirmButton || $[17] !== classes?.searchInput || $[18] !== confirmText || $[19] !== description || $[20] !== handleConfirm || $[21] !== handleKeyDown || $[22] !== isAddressValid || $[23] !== onBack || $[24] !== placeholder || $[25] !== recipientAddress || $[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== title) {
    let t17;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = e_0 => setRecipientAddress(e_0.target.value);
      $[31] = t17;
    } else {
      t17 = $[31];
    }
    let t18;
    if ($[32] !== isAddressValid || $[33] !== recipientAddress) {
      t18 = recipientAddress && !isAddressValid && _jsx("div", {
        className: "text-as-red text-sm",
        children: "Please enter a valid address"
      });
      $[32] = isAddressValid;
      $[33] = recipientAddress;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    t16 = _jsx("div", {
      className: t13,
      children: _jsxs("div", {
        className: "flex flex-col gap-6",
        children: [_jsxs("div", {
          className: t14,
          children: [_jsx("button", {
            onClick: onBack,
            className: t15,
            children: _jsx(ChevronLeft, {
              className: "h-6 w-6"
            })
          }), _jsxs("div", {
            className: "flex-1 text-center",
            children: [_jsx("h2", {
              className: "text-as-primary text-lg font-semibold",
              children: title
            }), _jsx("p", {
              className: "text-as-primary/60 text-sm",
              children: description
            })]
          })]
        }), _jsxs("div", {
          className: "flex flex-col gap-4",
          children: [_jsxs("div", {
            className: "bg-as-surface-secondary border-as-border-secondary flex h-12 w-full overflow-hidden rounded-xl border",
            children: [_jsx("input", {
              type: "text",
              placeholder,
              value: recipientAddress,
              onChange: t17,
              onKeyDown: handleKeyDown,
              className: classes?.searchInput || "text-as-primary placeholder:text-as-primary/50 flex-1 bg-transparent px-4 text-base focus:outline-none",
              autoFocus
            }), _jsx("div", {
              className: "border-as-border-secondary border-l",
              children: _jsx("button", {
                onClick: handlePaste,
                className: "text-as-primary/70 hover:text-as-primary hover:bg-as-surface-primary h-full px-4 font-semibold transition-colors",
                children: "Paste"
              })
            })]
          }), t18, _jsx("button", {
            onClick: handleConfirm,
            disabled: !canConfirm,
            className: classes?.confirmButton || "bg-as-brand hover:bg-as-brand/90 disabled:bg-as-on-surface-2 disabled:text-as-secondary h-12 w-full rounded-xl font-medium text-white transition-colors disabled:cursor-not-allowed",
            children: confirmText
          })]
        })]
      })
    });
    $[14] = autoFocus;
    $[15] = canConfirm;
    $[16] = classes?.confirmButton;
    $[17] = classes?.searchInput;
    $[18] = confirmText;
    $[19] = description;
    $[20] = handleConfirm;
    $[21] = handleKeyDown;
    $[22] = isAddressValid;
    $[23] = onBack;
    $[24] = placeholder;
    $[25] = recipientAddress;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = title;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}